<template>
  <div class="py-4 container-fluid">
    <div class="card">
      <form @submit.prevent="submit" class="card-body">
        <div class="row">
          <div v-if="getPermission(1060).view | getPermission(1110).view" class="col-md-6">
            <label class="form-control-label">شرکت</label>
            <treeselect v-model="companyId" :multiple="false" :disabled="(!getPermission(1060).view)"
              :placeholder="(customerId || !companyId) ? '' : companyTitle" :showCount="true"
              noOptionsText="هنوز شرکتی تعریف نشده است" noResultsText="موردی یافت نشد"
              noChildrenText="این شرکت فاقد زیر مجموعه است" :options="companies" @open="reloadCompanies" />
          </div>
          <div :class="(getPermission(1060).view | getPermission(1110).view) ? 'col-md-6' : ''">
            <label class="form-control-label">مشتری والد</label>
            <treeselect v-model="customerId" :multiple="false" :placeholder="customerId ? customerTitle : ''"
              :showCount="true" noOptionsText="هنوز مشتری ای تعریف نشده است" noResultsText="موردی یافت نشد"
              noChildrenText="این مشتری فاقد زیر مجموعه است" :options="customers"
              :class="(getPermission(1060).view | getPermission(1110).view) ? '' : 'col-md-6'" @open="reloadCustomers" />
          </div>
          <div class="col-md-6">
            <label class="form-control-label required" for="title">نام مشتری</label>
            <input class="form-control" type="text" id="title" name="title" v-model.trim="title" />
          </div>
          <div class="col-md-6">
            <label class="form-control-label" for="phone">تلفن مشتری</label>
            <input class="form-control" type="text" id="phone" name="phone" v-model.trim="phone" />
          </div>
          <div class="col-md-6">
            <label class="form-control-label" for="maxActiveUsers">حداکثر کاربران فعال</label>
            <input class="form-control" type="number" id="maxActiveUsers" name="maxActiveUsers" v-model="maxActiveUsers" />
          </div>
          <div class="col-md-6">
            <label class="form-control-label" for="expirationDate">تاریخ پایان اعتبار</label>
            <custom-date-picker :selectedDate="expirationDate" @update:selectedDate="setDate" />
          </div>
          <div class="col-md-4">
            <label class="form-control-label required" for="countryTitle">کشور</label>
            <vue-select v-model="country" :options="countries" dir="rtl" label="title">
              <template #no-options="{ search, searching, loading }">
                موردی یافت نشد!
              </template>
            </vue-select>
          </div>
          <div class="col-md-4">
            <label class="form-control-label required" for="provinceTitle">استان</label>
            <vue-select v-model="province" :options="provinces" dir="rtl" label="title">
              <template #no-options="{ search, searching, loading }">
                موردی یافت نشد!
              </template>
            </vue-select>
          </div>
          <div class="col-md-4">
            <label class="form-control-label required" for="countyTitle">شهر</label>
            <vue-select v-model="county" :options="counties" dir="rtl" label="title">
              <template #no-options="{ search, searching, loading }">
                موردی یافت نشد!
              </template>
            </vue-select>
          </div>
          <div>
            <label class="form-control-label" for="address">آدرس مشتری</label>
            <textarea class="form-control" id="address" name="address" v-model.trim="address" />
          </div>
        </div>
        <hr class="horizontal dark" />
        <template v-if="v.$error">
          <show-errors :model-value="v.$errors"></show-errors>
          <hr class="horizontal dark" />
        </template>
        <div>
          <button class="btn bg-gradient-success mb-0" type="submit">ثبت</button>
          <button class="btn bg-gray-400 me-3 float-start mb-0" type="button" @click="goBack">بازگشت</button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import CustomerService from '@/services/Company/Customer-service.js';
import AddressService from '@/services/Address/Address-service.js';
import { maxLength, helpers, requiredIf, required, not, sameAs, minValue } from '@vuelidate/validators';
import Treeselect from '@cholakovdev/vue3-treeselect';
import CustomDatePicker from '../components/CustomDatePicker.vue';
import { mapMutations, mapGetters } from "vuex";

export default {
  components: { Treeselect, CustomDatePicker },
  data() {
    return {
      v: this.$useVuelidate(),
      id: null,
      title: '',
      phone: '',
      maxUsers: null,
      country: {},
      countryId: null,
      province: {},
      provinceId: null,
      county: {},
      countyId: null,
      address: '',
      countries: [],
      provinces: [],
      counties: [],
      isNew: true,
      companies: [],
      companyId: null,
      customers: [],
      customerId: null,
      oldId: null,
      companyTitle: null,
      customerTitle: null,
      maxActiveUsers: null,
      expirationDate: null,
    };
  },
  computed:{
    ...mapGetters(['getPermission']),
  },
  watch: {
    companyId(companyId) {
      if (typeof (companyId) === 'number' && typeof (this.customerId) === 'number' && this.getPermission(1060).view) {
        this.customers = [{ id: this.customerId, label: '', pH: true }];
        this.oldId = this.customerId;
        this.customerId = null;
      }
    },
    customerId(customerId) {
      if (typeof (customerId) === 'number' && typeof (this.companyId) === 'number' && this.getPermission(1060).view) {
        this.companies = [{ id: this.companyId, label: '', pH: true }];
        this.oldId = this.companyId;
        this.companyId = null;
      }
    },
    countries(countries){
      if(this.isNew & countries != null & countries.length > 0){
        this.country = countries[countries.findIndex((value) => value.id == 3)];
      }
    },
    country(country) {
      if (country) {
        this.getProvinces();
        this.countryId = country.id;
        this.province = {};
      }
      else {
        this.provinces = [];
        this.province = {};
        this.countryId = null;
      }
    },
    province(province) {
      if (province) {
        this.getCounties();
        this.provinceId = province.id;
        this.county = {};
      }
      else {
        this.counties = [];
        this.county = {};
        this.provinceId = null;
      }
    },
    county(county) {
      if (county) {
        this.countyId = county.id;
      }
      else {
        this.countyId = null;
      }
    }
  },
  methods: {
    ...mapMutations(["setCurrentUserInfo"]),
    getCustomers() {
      CustomerService.getCustomerList().then(response => {
        let result = response.data;

        if (!result.success) {
          this.$toast.error(result.message);
        }
        else {
          this.customers = result.data;
        }
      }).catch(e => {
        console.log(e);
      })
    },
    submit() {
      this.v.$validate();

      if (this.v.$error) {
        return;
      }

      let newCustomer = {
        Title: this.title,
        Phone: this.phone,
        Address: this.address,
        CountyId: this.county.id,
        MaxActiveUsers: 0,
        CompanyId: this.companyId ?? this.oldId,
        ParentId: this.customerId,
        maxActiveUsers: this.maxActiveUsers,
        expirationDate: this.expirationDate,
      };

      let editedCustomer = { Id: this.id, ...newCustomer };

      if (!this.isNew) {
        CustomerService.updateCustomer(editedCustomer).then(response => {
          let result = response.data;

          if (result.success) {
            this.$toast.success(result.message);

            if (this.$store.state.currentUserInfo.isCompanyUser) {
              this.getUserCustomersByCompany(this.$store.state.currentUserInfo.companies.allIds);
            }
            else {
              this.getUserCustomersByCustomer(this.$store.state.currentUserInfo.customerId);
            }
          } else {
            this.$toast.error(result.message);
          }
        }).catch(e => {
          console.log(e);
        });
      }
      else {
        newCustomer.CompanyId = this.$store.state.currentUserInfo.companyId;

        CustomerService.createCustomer(newCustomer).then(response => {
          let result = response.data;

          if (result.success) {
            this.$toast.success(result.message);

            if (this.$store.state.currentUserInfo.isCompanyUser) {
              this.getUserCustomersByCompany(this.$store.state.currentUserInfo.companies.allIds);
            }
            else {
              this.getUserCustomersByCustomer(this.$store.state.currentUserInfo.customerId);
            }
          } else {
            this.$toast.error(result.message);
          }
        }).catch(e => {
          console.log(e);
        });

        this.v.$reset();
      }
    },
    getCustomer() {
      CustomerService.getCustomer(this.id).then(response => {
        let result = response.data;

        if (result.success) {
          this.title = result.data.title;
          this.phone = result.data.phone;
          this.address = result.data.address;
          this.maxUsers = result.data.maxActiveUsers;
          setTimeout(() => { this.customerId = result.data.parentId; }, 250);
          setTimeout(() => this.county = { id: result.data.countyId, title: result.data.countyTitle }, 100);
          setTimeout(() => this.province = { id: result.data.provinceId, title: result.data.provinceTitle }, 50);
          this.country = { id: result.data.countryId, title: result.data.countryTitle };
          this.companyId = this.$store.state.currentUserInfo.isCompanyUser ? result.data.companyId : null;
          this.customerTitle = result.data.parentTitle;
          this.companyTitle = result.data.companyTitle;
          this.maxActiveUsers = result.data.maxActiveUsers;
          this.expirationDate = result.data.expirationDate?.toString();
        } else {
          this.$toast.error(result.message);
        }
      }).catch(e => {
        console.log(e);
      });
    },
    getCountries() {
      AddressService.getCountries().then(response => {
        let result = response.data;

        if (result.success) {
          this.countries = result.data;
        }
        else {
          this.toast.error(result.message);
        }
      }).catch(e => {
        console.log(e);
      });
    },
    getProvinces() {
      let countryId = this.country.id;

      AddressService.getProvincesByCountry(countryId).then(response => {
        let result = response.data;

        if (result.success) {
          this.provinces = result.data;
        }
        else {
          this.toast.error(result.message);
        }
      }).catch(e => {
        console.log(e);
      });
    },
    getCounties() {
      let provinceId = this.province.id;

      if (provinceId) {
        AddressService.getCountiesByProvince(provinceId).then(response => {
          let result = response.data;

          if (result.success) {
            this.counties = result.data;
          }
          else {
            this.toast.error(result.message);
          }
        }).catch(e => {
          console.log(e);
        });
      }
    },
    goBack() {
      this.$router.back();
    },
    reloadCompanies() {
      if (this.companies[0].pH & this.getPermission(1060).view) {
        this.companyId = this.oldId;
        this.companies = [];
        this.companies.push(this.$store.state.currentUserInfo.companies);
      }
    },
    reloadCustomers() {
      if (this.customers[0].pH & this.getPermission(1060).view) {
        this.customerId = this.oldId;
        this.customers = [];
        this.customers = this.$store.state.currentUserInfo.customers;
      }
    },
    getUserCustomersByCompany(companyIds) {
      CustomerService.getUserCustomersByCompany(companyIds).then(response => {
        let result = response.data;

        if (result.success) {
          this.setCurrentUserInfo({ customers: result.data });
        }
        else {
          this.$toast.error(result.message);
        }

        setTimeout(() => this.$router.back(), 500);
      }).catch(e => {
        console.log(e);
      });
    },
    getUserCustomersByCustomer(customerId) {
      CustomerService.getUserCustomersByCustomer(customerId).then(response => {
        let result = response.data;

        if (result.success) {
          this.setCurrentUserInfo({ customers: result.data });
        }
        else {
          this.$toast.error(result.message);
        }

        setTimeout(() => this.$router.back(), 500);
      }).catch(e => {
        console.log(e);
      });
    },
    setDate(date) {
      this.expirationDate = date ? (date.slice(0, 4) + date.slice(5, 7) + date.slice(8, 10)) : null;
    },
  },
  created() {
    this.isNew = this.$route.meta.new;
    this.getCountries();

    if (this.$store.state.currentUserInfo.companies) {
      this.companies.push(this.$store.state.currentUserInfo.companies);
      this.customers = this.$store.state.currentUserInfo.customers;
      if (this.isNew & (this.getPermission(1060).view | this.getPermission(1110).view)) {
        this.companyId = this.$store.state.currentUserInfo.companies.id;
      }
    }
    else {
      this.customers.push(this.$store.state.currentUserInfo.customers);
      if (this.isNew) { this.customerId = this.$store.state.currentUserInfo.customers.id; }
    }

    if (!this.isNew) {
      this.id = this.$route.params.customerId;
      setTimeout(() => this.getCustomer(), 500);
    }
  },
  validations() {
    let valObj = {
      customerId: {
        requiredIf: helpers.withMessage('لطفا "شرکت" مربوطه یا "مشتری والد" را انتخاب کنید', requiredIf(!this.companyId)),
        notSameAs: helpers.withMessage('"مشتری والد" معتبر نیست', not(sameAs(parseInt(this.id)))),
      },
      title: {
        required: helpers.withMessage('لطفا "نام مشتری" را وارد کنید', required),
        maxLength: helpers.withMessage('حد‌اکثر طول مجاز برای "نام مشتری"، 200 کاراکتر است', maxLength(200)),
      },
      phone: {
        //required: helpers.withMessage('لطفا "تلفن مشتری" را وارد کنید', required),
        maxLength: helpers.withMessage('حد‌اکثر طول مجاز برای "تلفن مشتری"، 50 کاراکتر است', maxLength(50)),
      },
      countryId: {
        required: helpers.withMessage('لطفا "کشور" را وارد کنید', required),
      },
      provinceId: {
        required: helpers.withMessage('لطفا "استان" را وارد کنید', required),
      },
      countyId: {
        required: helpers.withMessage('لطفا "شهر" را وارد کنید', required),
      },
      address: {
        //required: helpers.withMessage('لطفا "آدرس مشتری" را وارد کنید', required),
        maxLength: helpers.withMessage('حد‌اکثر طول مجاز برای "آدرس مشتری"، 500 کاراکتر است', maxLength(500)),
      },
      maxActiveUsers: {
        minValue: helpers.withMessage('مقدار وارد شده برای "حداکثر کاربران فعال" معتبر نیست', minValue(0)),
      },
    };

    return valObj;
  }
}
</script>